/**
 * @bryntum/grid and @bryntum/taskboard are separate product bundles that each
 * embed their own copy of Bryntum Core. When both are on the same version they
 * register the same global key and Core throws "bundle was loaded multiple
 * times". The npm packages don't ship the thin bundles that would let the two
 * products share one Core, so we acknowledge the duplication explicitly.
 *
 * Must be imported before any @bryntum/* module is evaluated.
 */
const globalScope = window;
globalScope.bryntum = globalScope.bryntum || {};
globalScope.bryntum.silenceBundleException = true;
export {};
